import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  DialogActions,
  Autocomplete,
  TextField,
} from '@mui/material';
import CustomButton from '../../../../../../../../../lib/designSystem/Button';
import { createCreditLine } from '../../../../../../../../../lib/api';
import { getAvailableCreditLineProducts } from '../../../../../../../../../lib/api/creditLine';
import { useDispatch, useSelector } from 'react-redux';
import CenteredCircularProgress from '../../../../../../../../../lib/designSystem/CircularProgress';
import { AuthState } from '../../../../../../../../../services/redux/authSlice';
import {
  showAlert,
  validaRut,
} from '../../../../../../../../../lib/functions/utils';

const CreateStakeholderCreditLineDialog = (props: any) => {
  const { open, setOpen, handleDetails, setUp } = props;
  const [loading, setLoading] = useState(false);
  const [product, setProduct] = useState('');
  const [businessIdentifier, setBusinessIdentifier] = useState('');
  const [availableProducts, setAvailableProducts] = useState([]);
  const [selectedBusiness, setSelectedBusiness] = useState(false);

  const user = useSelector((state: { auth: AuthState }) => state.auth.user);

  const dispatch = useDispatch();

  const handleCreateNew = async () => {
    setLoading(true);
    try {
      const creditLineResponse = await createCreditLine(dispatch, {
        businessIdentifier: businessIdentifier,
        status: 'NOT_REQUESTED',
        productId: product,
        creatorId: user?.id,
      });
      setLoading(false);
      await setUp();
      await handleDetails(creditLineResponse.id);
      return setOpen(false);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const handleContinue = async () => {
    if (!validaRut(businessIdentifier)) {
      showAlert(dispatch, 'error', 'Rut inválido');
      return;
    }
    setLoading(true);
    try {
      const response = await getAvailableCreditLineProducts(
        dispatch,
        businessIdentifier,
      );
      if (response.length > 0) {
        setAvailableProducts(response);
      } else {
        showAlert(dispatch, 'error', 'No hay productos disponibles');
        setLoading(false);
        return setOpen(false);
      }
    } catch (error) {
      showAlert(dispatch, 'error', 'Error al obtener productos disponibles');
    }
    setSelectedBusiness(true);
    setLoading(false);
  };

  return (
    <Dialog maxWidth="sm" open={open} onClose={() => setOpen(false)}>
      <DialogTitle>Solicitar línea de crédito</DialogTitle>
      {loading && (
        <DialogContent style={{ width: '500px' }}>
          <CenteredCircularProgress type="dialog" />
        </DialogContent>
      )}
      {!loading && (
        <DialogContent style={{ width: '500px' }}>
          <Typography variant="body1" gutterBottom>
            Acá podrás solicitar una línea de crédito para un deudor en algun
            producto en específico.
          </Typography>
          <div style={{ padding: '10px 0px' }}>
            <TextField
              label="Rut del deudor"
              fullWidth
              value={businessIdentifier}
              disabled={selectedBusiness}
              onChange={(e: any) => setBusinessIdentifier(e.target.value)}
            />
          </div>
          {selectedBusiness && (
            <div style={{ padding: '10px 0px' }}>
              <FormControl fullWidth variant="outlined">
                <InputLabel id="filter-label">Productos disponibles</InputLabel>
                <Select
                  labelId="filter-label"
                  id="Filtrar por estado"
                  name="product"
                  value={product}
                  onChange={(e: any) => setProduct(e.target.value)}
                  label="Productos disponibles"
                >
                  {availableProducts.map((x: any, index: any) => (
                    <MenuItem key={index} value={x.id}>
                      {x.type}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          )}
        </DialogContent>
      )}
      {!loading && (
        <DialogActions>
          <CustomButton
            onClick={() => setOpen(false)}
            color="secondary"
            variant="contained"
          >
            Cancelar
          </CustomButton>
          {!selectedBusiness && (
            <CustomButton
              onClick={() => handleContinue()}
              color="primary"
              variant="contained"
            >
              Continuar
            </CustomButton>
          )}
          {selectedBusiness && (
            <CustomButton
              onClick={() => handleCreateNew()}
              color="primary"
              variant="contained"
            >
              Comenzar
            </CustomButton>
          )}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default CreateStakeholderCreditLineDialog;
